<div class="tt-print-modal__preview">
    <span *ngIf="!previewLink || generating" class="loader" [ngClass]="generating ? 'loader-animate' : ''"></span>
    <embed *ngIf="previewLink && !generating" class="col-xs-12 sp-0" style="height: 100%; width: 100%; border: none" [src]="previewLink" />
    <!-- <ng-container *ngIf="generating" [ngTemplateOutlet]="spinner"></ng-container> -->
</div>
<ng-template #spinner>
    <span class="loader loader-animate"></span>
    <!-- <tt-grid-loading-overlay class="tt-grid-modal__no-layout" style="width: 100%; display: flex; justify-content: center"></tt-grid-loading-overlay> -->
</ng-template>
